export const toDealsSelect = deals => {
  return deals.map(deal => {
    return {
      value: deal.id,
      label: deal.name,
      clients: deal.dealCompanies
    }
  })
}
